/**
 * Used in backend to whitelist sizes
 * When sizes are changed or added, run `npm run build`
 */

/**
 * Values can be:
 * w (width)
 * h (height)
 * mw (max width)
 * mh (max height)
 * cw (crop width)
 * ch (crop height)
 */
export const imageSizes = {
	none: {
		mw: 10,
	},
	default: { //16:9
		sm: {
			cw: 384,
			ch: 216,
		},
		md: {
			cw: 768,
			ch: 432,
		},
		lg: {
			cw: 1152,
			ch: 648,
		},
		xl: {
			cw: 1440,
			ch: 810,
		}
	},
	header: {
		menu: {
			sm: {
				cw: 384,
				ch: 700,
			},
			md: {
				cw: 769,
				ch: 700,
			},
			lg: {
				cw: 227,
				ch: 491,
			},
			xl: {
				cw: 338,
				ch: 490,
			}
		},
	},
	listing: {
		articles: {
			sm: {
				cw: 130,
				ch: 147,
			},
			md: {
				cw: 130,
				ch: 147,
			},
			lg: {
				cw: 285,
				ch: 190,
			},
			xl: {
				cw: 435,
				ch: 295,
			}
		},
		podcasts: {
			sm: {
				cw: 265,
				ch: 265,
			},
			md: {
				cw: 200,
				ch: 200,
			},
			lg: {
				cw: 250,
				ch: 250,
			},
			xl: {
				cw: 385,
				ch: 385,
			}
		},
		issue: {
			sm: {
				mw: 155,
				mh: 190,
			},
			md: {
				mw: 345,
				mh: 425,
			},
			lg: {
				mw: 140,
				mh: 175,
			},
			xl: {
				mw: 240,
				mh: 300,
			}
		},
		slider: {
			sm: {
				cw: 270,
				ch: 300,
			},
			md: {
				cw: 220,
				ch: 250,
			},
			lg: {
				cw: 280,
				ch: 190,
			},
			xl: {
				cw: 435,
				ch: 295,
			}
		}
	},
	contentImages: {
		halfWidth: {
			sm: {
				cw: 170,
				ch: 190,
			},
			md: {
				cw: 360,
				ch: 410,
			},
			lg: {
				cw: 450,
				ch: 500,
			},
			xl: {
				cw: 500,
				ch: 560,
			}
		},
		thirdWidth: {
			sm: {
				cw: 360,
				ch: 200,
			},
			md: {
				cw: 730,
				ch: 415,
			},
			lg: {
				cw: 230,
				ch: 370,
			},
			xl: {
				cw: 260,
				ch: 360,
			}
		}
	},
	timeline: { //16:9
		sm: {
			cw: 384,
			ch: 188,
		},
		md: {
			cw: 698,
			ch: 412,
		},
		lg: {
			cw: 300,
			ch: 335,
		},
		xl: {
			cw: 300,
			ch: 335,
		}
	},
	featuredBanner: {
		large: {
			sm: {
				mw: 350,
				mh: 600,
			},
			md: {
				mw: 730,
				mh: 700,
			},
			lg: {
				cw: 430,
				ch: 300,
			},
			xl: {
				cw: 700,
				ch: 500,
			},
		},
		slim: {
			sm: {
				mw: 350,
				mh: 600,
			},
			md: {
				mw: 730,
				mh: 700,
			},
			lg: {
				cw: 430,
				ch: 340,
			},
			xl: {
				cw: 660,
				ch: 340,
			},
		},
	},
	contributors: {
		list: {
			sm: {
				mw: 140,
				mh: 165,
			},
			md: {
				mw: 290,
				mh: 350,
			},
			lg: {
				cw: 100,
				ch: 123,
			},
			xl: {
				cw: 130,
				ch: 160,
			}
		},
		slider: {
			sm: {
				mw: 270,
				mh: 330,
			},
			md: {
				mw: 200,
				mh: 240,
			},
			lg: {
				cw: 250,
				ch: 310,
			},
			xl: {
				cw: 400,
				ch: 480,
			}
		},
		grid: {
			sm: {
				cw: 270,
				ch: 410,
			},
			md: {
				cw: 520,
				ch: 500,
			},
			lg: {
				cw: 500,
				ch: 720,
			},
			xl: {
				cw: 340,
				ch: 700,
			}
		}
	},
	pageHeader: {
		article: {
			sm: {
				cw: 395,
				ch: 585,
			},
			md: {
				cw: 770,
				ch: 825,
			},
			lg: {
				cw: 995,
				ch: 825,
			},
			xl: {
				cw: 1441,
				ch: 825,
			}
		},
		issue: {
			sm: {
				mw: 360,
				mh: 430,
			},
			md: {
				mw: 535,
				mh: 650,
			},
			lg: {
				mw: 450,
				mh: 540,
			},
			xl: {
				mw: 540,
				mh: 650,
			}
		}
	},
	imageGallery: {
		carousel: {
			sm: {
				mw: 384,
			},
			md: {
				mw: 768,
			},
			lg: {
				mw: 1152,
			},
			xl: {
				mw: 1440,
			}
		},
		thumbnail: {
			sm: {
				cw: 60,
				ch: 60,
			},
			md: {
				cw: 85,
				ch: 85,
			},
			lg: {
				cw: 75,
				ch: 75,
			},
			xl: {
				cw: 110,
				ch: 110,
			}
		}
	}
};